import _slicedToArray from "/home/travis/build/Arquisoft/viade_es4b/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from 'react';
import useLDflex from '../hooks/useLDflex';
/** Displays the value of a Solid LDflex expression. */

export default function Value(_ref) {
  var src = _ref.src,
      children = _ref.children;

  var _useLDflex = useLDflex(src),
      _useLDflex2 = _slicedToArray(_useLDflex, 3),
      value = _useLDflex2[0],
      pending = _useLDflex2[1],
      error = _useLDflex2[2]; // Render stringified value


  if (value !== undefined && value !== null) return "".concat(value); // Render pending state
  else if (pending) return children || /*#__PURE__*/React.createElement("span", {
      className: "solid value pending"
    }); // Render error state
    else if (error) return children || /*#__PURE__*/React.createElement("span", {
        className: "solid value error",
        "data-error": error.message
      }); // Render empty value
      else return children || /*#__PURE__*/React.createElement("span", {
          className: "solid value empty"
        });
}